export const getSecretHeader = () => {
  return {
    'x-tgj-token': 'tgj-67935680',
  }
}

export const getAdminAppSecretHeader = () => {
  return {
    'x-tg-token': 'tg-70925739',
  }
}
